import isEmpty from 'lodash-es/isEmpty';

import { Button, ButtonVariantType } from '@gn-audio/jss-components';

import { useCondensedMenu } from 'common/condensedMenu/CondensedMenuProvider';

interface CondensedMenuLinkProps {
  anchorAction: (event: React.MouseEvent<HTMLButtonElement>, anchor: string) => void;
}

export const CondensedMenuLink = ({ anchorAction }: CondensedMenuLinkProps) => {
  const { settings } = useCondensedMenu();
  const { linkText, linkButtonVariant, link } = settings;

  if ([linkText, linkButtonVariant, link].some(isEmpty)) {
    return null;
  }

  const processAnchorClickEvent = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!link?.value?.anchor) {
      return;
    }

    anchorAction(event, link.value.anchor);
  };

  if (!link) {
    return null;
  }

  return link.value.linktype === 'anchor' ? (
    <Button
      variant={linkButtonVariant as ButtonVariantType}
      size="s"
      onClick={processAnchorClickEvent}
      {...(settings.linkAriaLabel && { 'aria-label': settings.linkAriaLabel })}
    >
      {linkText}
    </Button>
  ) : (
    <Button
      variant={linkButtonVariant as ButtonVariantType}
      size="s"
      asLink
      href={link.value.href}
      {...(settings.linkAriaLabel && { 'aria-label': settings.linkAriaLabel })}
    >
      {linkText}
    </Button>
  );
};
